<div class="ir-area ir-mask th-mask" *ngIf="point">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="updatePoint(editForm.value)">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'points.edit-notes' | translate: point }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content full-height">
        <h2>
          <span>{{ 'points.my-notes' | translate }}</span>
        </h2>
        <div class="ir-form-group">
          <textarea
            formControlName="notes"
            placeholder="{{ 'points.placeholders.your-notes' | translate }}"
            class="ir-form-set"
            innertHtml="notess"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
